const mtnServiceID = `${process.env.REACT_APP_MTN_SERVICE_ID}`;
const vodafoneServiceID = `${process.env.REACT_APP_VODAFONE_SERVICE_ID}`;

const getServiceProvider = async (number) => {

	const mtnCode = ["23324", "23354", "23355", "23359", "23325"];
	const telecelCode = ["23320", "23350"];
	// const tigoAirtelCode = ["23327.", "23357", "23326.", "23356"];
	let serviceProvider = "";

	if (mtnCode.includes(number.substring(0, 5))) {
		serviceProvider = mtnServiceID;
	}

	if (telecelCode.includes(number.substring(0, 5))) {
		serviceProvider = vodafoneServiceID;
	}
	// if (tigoAirtelCode.includes(number.substring(0, 5))) {
	// 	serviceProvider = vodafoneServiceID;
	// }

	return serviceProvider;
};

export default getServiceProvider;
